import * as React from 'react'

import { observer } from 'mobx-react'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportEmployeeSelector from '../../ExportFields/ExportEmployeeSelector'
import ExportLeaveSelector from '../../ExportFields/ExportLeaveSelector'
import ExportMonthSelector from '../../ExportFields/ExportMonthSelector'

interface Props {
  form: ReportsForm
}

const ScheduleTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ExportLeaveSelector form={form} />
      <ExportMonthSelector form={form} />
    </>
  )
}

export default observer(ScheduleTimeoffFields)
